<div class="class dropdown-container d-flex justify-content-between align-items-center">
    <div *ngIf="isLabelled" class="label">
        <span>{{ label }}</span>
    </div>
    <div [class.not-labelled]="!isLabelled" class="dropdown" (click)="toggleDropdown()">
        <span>{{ selected || 'Select...' }}</span>
        <img width="12" height="12" src="../../../../assets/icons/arrow-down-small.svg" />
    </div>
    <ul class="options" *ngIf="isOpen && !disabled">
      <li *ngFor="let opt of options" (click)="selectOption(opt, $event)">
        {{ opt.label }}
      </li>
    </ul>
</div>
